'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp2;

var _ChooserClassColor = require('./ChooserClassColor');

var _ChooserClassColor2 = _interopRequireDefault(_ChooserClassColor);

var _constants = require('./constants');

require('./style.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    ColorChooser: {
        displayName: 'ColorChooser'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/ColorChooser/index.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var ColorChooser = _wrapComponent('ColorChooser')((_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(ColorChooser, _Component);

    function ColorChooser() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ColorChooser);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ColorChooser.__proto__ || (0, _getPrototypeOf2.default)(ColorChooser)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (color) {
            new _ChooserClassColor2.default().chooseClass(color);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ColorChooser, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react3.default.createElement(
                'div',
                { className: 'color-chooser' },
                _react3.default.createElement(
                    'div',
                    { className: 'color-chooser-options' },
                    _react3.default.createElement(
                        'ul',
                        { className: 'list-unstyled' },
                        _react3.default.createElement(
                            'li',
                            null,
                            _react3.default.createElement(
                                'a',
                                { className: 'changecolor', href: '#', title: '\u0417\u0435\u043B\u0451\u043D\u044B\u0439', onClick: function onClick(e) {
                                        e.preventDefault();
                                        _this2.onClick(_constants.GREEN);
                                    } },
                                _react3.default.createElement('div', { className: 'color-box color-box-green' })
                            )
                        ),
                        _react3.default.createElement(
                            'li',
                            null,
                            _react3.default.createElement(
                                'a',
                                { className: 'changecolor', href: '#', title: '\u0413\u043E\u043B\u0443\u0431\u043E\u0439', onClick: function onClick(e) {
                                        e.preventDefault();
                                        _this2.onClick(_constants.BLUE);
                                    } },
                                _react3.default.createElement('div', { className: 'color-box color-box-blue' })
                            )
                        ),
                        _react3.default.createElement(
                            'li',
                            null,
                            _react3.default.createElement(
                                'a',
                                { className: 'changecolor', href: '#', title: '\u041A\u0440\u0430\u0441\u043D\u044B\u0439', onClick: function onClick(e) {
                                        e.preventDefault();
                                        _this2.onClick(_constants.RED);
                                    } },
                                _react3.default.createElement('div', { className: 'color-box color-box-red' })
                            )
                        ),
                        _react3.default.createElement(
                            'li',
                            null,
                            _react3.default.createElement(
                                'a',
                                { className: 'changecolor', href: '#', title: '\u041E\u0440\u0430\u043D\u0436\u0435\u0432\u044B\u0439', onClick: function onClick(e) {
                                        e.preventDefault();
                                        _this2.onClick(_constants.ORANGE);
                                    } },
                                _react3.default.createElement('div', { className: 'color-box color-box-orange' })
                            )
                        ),
                        _react3.default.createElement(
                            'li',
                            null,
                            _react3.default.createElement(
                                'a',
                                { className: 'changecolor', href: '#', title: '>\u0422\u0435\u043C\u043D\u043E-\u0441\u0438\u043D\u0438\u0439', onClick: function onClick(e) {
                                        e.preventDefault();
                                        _this2.onClick(_constants.NAVY);
                                    } },
                                _react3.default.createElement('div', { className: 'color-box color-box-navy' })
                            )
                        ),
                        _react3.default.createElement(
                            'li',
                            null,
                            _react3.default.createElement(
                                'a',
                                { className: 'changecolor', href: '#', title: '\u0422\u0435\u043C\u043D\u043E-\u0437\u0435\u043B\u0451\u043D\u044B\u0439', onClick: function onClick(e) {
                                        e.preventDefault();
                                        _this2.onClick(_constants.DARK_GREEN);
                                    } },
                                _react3.default.createElement('div', { className: 'color-box color-box-dark-green' })
                            )
                        )
                    )
                )
            );
        }
    }]);
    return ColorChooser;
}(_react2.Component), _class.propTypes = {}, _temp2));

exports.default = ColorChooser;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ColorChooser/index.jsx
// module id = 1642
// module chunks = 0